import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alertModal',
  templateUrl: './alertModal.component.html',
  styleUrls: ['./alertModal.component.scss']
})
export class AlertModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AlertModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { type: string, msg: string, obs: string, confirm?: boolean, showOk?: boolean },
  ) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(this.data.confirm);
  }

}
